import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { AIDES_ENTREPRISES } from '../../../../config/aides-entreprises';

export default function ExonerationCspePage() {
  const aide = AIDES_ENTREPRISES.find((a) => a.slug === 'exoneration-cspe');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="entreprises" />;
}
